import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import download from '../../reports/images/download-doc.svg';
import "react-daterange-picker/dist/css/react-calendar.css";
import Avatar from "@mui/material/Avatar";
import spinner from '../../assign-prescriptions/images/spinner.gif';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { IconButton, Grid, Box } from "@mui/material";
import moment from 'moment-timezone';
import { withTranslation } from "react-i18next";
import getTypeByLang from '../../common/typeByLang';
import ReportsAGGrid from "../reportsGrid/reportsAGGrid";
import CloseIcon from '@mui/icons-material/Close';

const styles = theme => ({
  root: {
    width: "100%",
  },
  table: {
    minWidth: 1020
  },
  padding10px: {
    padding: '10px'
  },
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none'
  },
  rowheight: {
    height: '35px'
  },
  primaryButton: {
    background: '#6cca98',
    color: '#fff',
    '&:hover': {
      background: '#6cca98',
      color: '#fff',
    },
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.38)',
      cursor: 'not-allowed',
      background: '#E4E5E8'
    },
  }
});

const TransactionSortObj = {
  firstname: { tableName: 'customers', sortColumn: 'first_name' },
  lastname: { tableName: 'customers', sortColumn: 'last_name' },
  store: { tableName: 'accounts', sortColumn: 'name' },
  box: { tableName: 'boxes', sortColumn: 'name' },
  deliverytype: { tableName: 'locationtype_master', sortColumn: 'name' },
  rxno: { tableName: 'prescription_detail', sortColumn: 'rx_no' },
  fillid: { tableName: 'prescription_detail', sortColumn: 'fillnumber' },
  prescriptionnumber: { tableName: 'prescription_detail', sortColumn: 'prescriptionnumber' },
  pucode: { tableName: 'prescriptions_master', sortColumn: 'pucode' },
  ndccode: { tableName: 'prescription_detail', sortColumn: 'ndc_code' },
  drugname: { tableName: 'prescription_detail', sortColumn: 'drug_name' },
  qty: { tableName: 'prescription_detail', sortColumn: 'qty' },
  price: { tableName: 'prescription_detail', sortColumn: 'price' },
  isConsultRequested: { tableName: 'prescription_detail', sortColumn: 'is_consult_requested' },
  transaction_date: { tableName: '', sortColumn: 'created_on' },
  username: { tableName: 'users', sortColumn: 'name' },
  status: { tableName: 'prescriptions_master', sortColumn: 'type_id' }
}

let TransactionFilterObj = {
  store_ids: [],
  box_ids: [],
  locationtype_ids: [],
  status_ids: [],
  fromdate: '',
  todate: '',
  pageNo: 0,
  pageSize: 25,
  sortOrder: 'desc',
  sortColumn: 'created_on',
  tableName: ''
}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class ConsoleReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rowsPerPage: 25,
      boxvalues: [],
      accountValues: [],
      locationvalues: [],
      statusvalues: [],
      loader: false,
      selectedObject: null,
      isButtonDisabled: false,
    };
  }

  componentDidMount() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + "accounts", {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(accounts => {
        const storelist = accounts.map(account => {
          return { id: account.id, name: account.name };
        });
        this.setState({ accountValues: storelist, parent_account_id: storelist[0].id });
        this.BindBoxesbyStoreId(storelist.map(x => x.id));
        this.GetLocationTypes();
        this.GetOrderStatus();
        this.setState({ loader: false });
      });
  }

  convertToTimeZone = (requestDate) => {
    const currentUserLang = localStorage.getItem('i18nextLng');
    let zone;
    zone = sessionStorage.getItem('timeZone');
    const date = moment(new Date(requestDate));
    if (['null', null, 'undefined', undefined].includes(zone)) {
      zone = defaultZone;
    }
    return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
  }

  exportCSV() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + "CSV/ConsoleReport", {
      method: 'POST',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(TransactionFilterObj)
    })
      .then(response => response.json())
      .then(csvData => {
        this.setState({ loader: false });
        let csvRow = [];
        let Array = [['StoreID', 'FirstName', 'LastName', 'Store', 'Box', 'DeliveryType', 'BIN', 'RxNo', 'Fill ID', 'Prescription Number', 'StockCode', 'PickUpCode', 'NDC Code', 'Drug Name', 'Qty', 'Amount Due', 'Fill Date', 'Stock Date', 'Pick Up Date']];
        let result = csvData && csvData.Results && csvData.Results.length > 0 ? csvData.Results : [];
        if (result !== undefined && result !== 'undefined') {
          if (result && result.length > 0) {
            for (let i of result) {
              Array.push(
                [
                  i.firstname,
                  i.lastname,
                  i.store,
                  i.box,
                  i.location_name,
                  i.binid,
                  i.rxno,
                  i.fillid,
                  i.prescriptionnumber,
                  i.stock_code,
                  i.pucode,
                  i.ndccode,
                  i.drugname ? i.drugname.replaceAll(',', ' ').trim() : '',
                  i.qty,
                  i.price ? '$' + parseFloat(i.price).toFixed(2) : '$0.00',
                  i.filldate ? this.convertToTimeZone(i && i.filldate) : '',
                  i.stockeddate ? this.convertToTimeZone(i && i.stockeddate) : '',
                  i.pickupdate ? this.convertToTimeZone(i && i.pickupdate) : '',
                ]
              );
            }

            for (let i of Array) {
              csvRow.push(i.join(","));
            }
            let csvString = csvRow.join("%0A");
            let element = document.createElement("a");
            element.href = 'data:attachment/csv.' + csvString;
            element.target = "_Blank";
            element.download = "ConsoleReport.csv";
            document.body.appendChild(element);
            element.click();
          }
        }
      })
  };

  //Bind Boxes by store id
  BindBoxesbyStoreId(store_ids) {
    if (store_ids.length > 0) {
      this.setState({ loader: true });
      let BoxesObj = {
        store_ids: store_ids
      }
      fetch(process.env.REACT_APP_BASEURL + 'getBoxesByStoreIds', {
        method: 'post',
        withCredentials: true,
        headers: {
          'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(BoxesObj)
      })
        .then(response => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        })
        .then(data => {
          const boxlist = data.map(account => {
            return { id: account.id, name: account.name };
          });
          this.setState({ boxvalues: boxlist });
          this.setState({ loader: false });
        });
    }
  }

  GetLocationTypes() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'deliveryreport/getLocationTypes', {
      method: 'get',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
    })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then(data => {
        const locationlist = data.map(location => {
          return { id: location.id, name: location.name };
        });
        this.setState({ locationvalues: locationlist });
        this.setState({ loader: false });
      });
  }

  GetOrderStatus() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'deliveryreport/getOrderStatus', {
      method: 'get',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
    })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then(data => {
        const statuslist = data.map(status => {
          return { id: status.id, name: status.name };
        });
        this.setState({ statusvalues: statuslist });
        this.setState({ loader: false });
      });
  }


  onGridReady = (params) => {
    this.gridApi = params.api
    const datasource = this.getServerSideDatasource(this.state.boxvalues, this.state.accountValues, this.state.locationvalues, this.state.statusvalues)
    // register datasource with the grid
    this.gridApi.setServerSideDatasource(datasource);
  }

  clearFilters = () => {
    const filterModel = this.gridApi.getFilterModel();
    if (Object.keys(filterModel).length > 0) {
      this.gridApi.setFilterModel(null);
      TransactionFilterObj.searchObject = null;
      TransactionFilterObj.box_ids = [];
      TransactionFilterObj.store_ids = [];
      TransactionFilterObj.locationtype_ids = [];
      TransactionFilterObj.status_ids = [];
      TransactionFilterObj.fromdate = '';
      TransactionFilterObj.todate = '';
      this.gridApi.refreshServerSide();
    }
  };

  getServerSideDatasource = (boxvalues, accountValues, locationvalues, statusvalues) => {
    const self = this;
    return {
      getRows(params) {
        TransactionFilterObj.pageNo = Math.floor(params.request.startRow / self.state.rowsPerPage)
        console.log(TransactionFilterObj.pageNo)

        const filterObject = params.request && params.request.filterModel
        const filterColumns = Object.keys(filterObject)

        // to set box_ids
        if (filterObject.box) {
          const filterValues = filterObject.box.values;
          if (filterValues.length > 0) {
            TransactionFilterObj.box_ids = boxvalues.filter(boxes => {
              return filterValues.includes(boxes.name)
            }).map(box => box.id)
          }
        } else {
          TransactionFilterObj.box_ids = []
        }

        // to set store_ids
        if (filterObject.store) {
          const filterValues = filterObject.store.values;
          TransactionFilterObj.store_ids = accountValues.filter(accounts => {
            return filterValues.includes(accounts.name)
          }).map(store => store.id)
        } else {
          TransactionFilterObj.store_ids = []
        }

        // to set locationtype_ids
        if (filterObject.deliverytype) {
          const filterValues = filterObject.deliverytype.values;
          TransactionFilterObj.locationtype_ids = locationvalues.filter(location => {
            return filterValues.includes(location.name)
          }).map(location => location.id)
        } else {
          TransactionFilterObj.locationtype_ids = []
        }

        // to set status_ids
        if (filterObject.status) {
          const filterValues = filterObject.status.values;
          TransactionFilterObj.status_ids = statusvalues.filter(status => {
            return filterValues.includes(status.name)
          }).map(status => status.id)
          console.log(statusvalues)
        } else {
          TransactionFilterObj.status_ids = []
        }

        // to set fromdate and todate
        if (filterObject.transaction_date) {
          const dateValue = filterObject.transaction_date;
          if (dateValue.operator) {
            // for date range
            if (dateValue.condition1.type === 'fromdate' && dateValue.condition2.type === 'todate') {
              const date1 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
              const date2 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
              TransactionFilterObj.fromdate = date1
              TransactionFilterObj.todate = date2
            }
            if (dateValue.condition2.type === 'fromdate' && dateValue.condition1.type === 'todate') {
              const date2 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
              const date1 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
              TransactionFilterObj.fromdate = date1
              TransactionFilterObj.todate = date2
            }
          } else {
            // for from/to date
            const date = moment(dateValue.dateFrom).format('YYYY-MM-DD')
            if (dateValue.type === 'fromdate') {
              TransactionFilterObj.fromdate = date
              TransactionFilterObj.todate = ''
            } else {
              TransactionFilterObj.todate = date
              TransactionFilterObj.fromdate = ''
            }
          }
        } else {
          TransactionFilterObj.todate = '';
          TransactionFilterObj.fromdate = ''
        }

        if (filterObject) {
          if (filterColumns.length === 0) {
            TransactionFilterObj.searchObject = null
          } else {
            TransactionFilterObj.searchObject = filterObject
          }
        }

        if (params.request.sortModel.length > 0) {
          TransactionFilterObj.tableName = TransactionSortObj[params.request.sortModel[0].colId].tableName
          TransactionFilterObj.sortColumn = TransactionSortObj[params.request.sortModel[0].colId].sortColumn
          TransactionFilterObj.sortOrder = params.request.sortModel[0].sort
        }

        const isStoreNotSelected = Boolean(filterObject.store && filterObject.store.values.length === 0)
        const isBoxNotSelected = Boolean(filterObject.box && filterObject.box.values.length === 0)
        const isLocationTypeNotSelected = Boolean(filterObject.deliverytype && filterObject.deliverytype.values.length === 0)
        const isStatusNotSelected = Boolean(filterObject.status && filterObject.status.values.length === 0)

        if (isStoreNotSelected === true || isBoxNotSelected === true || isLocationTypeNotSelected === true || isStatusNotSelected === true) {
          // store or box is not selected, so empty data
          params.successCallback([], 0)
          self.setState({ data: [], isButtonDisabled: true })
        } else { // store or box is selected
          apiCall()
        }

        function apiCall() {
          self.setState({ loader: true });
          console.log("api call")
          fetch(process.env.REACT_APP_BASEURL + 'deliveryreport/console-report', {
            method: 'post',
            withCredentials: true,
            headers: {
              Authorization:
                'Bearer ' +
                JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                  .jwtToken,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(TransactionFilterObj),
          })
            .then((httpResponse) => {
              try {
                return httpResponse.json();
              } catch (error) {
                return null;
              }
            })
            .then((response) => {
              if (response && response.results) {
                if (response.results.length > 0) {
                  console.log("data")
                  params.successCallback(response.results, response.total);
                  self.setState({ data: response.results, isButtonDisabled: false })
                } else {
                  console.log("no data")
                  params.successCallback([], 0);
                  self.setState({ data: [], isButtonDisabled: true })
                }
                self.setState({ loader: false })
              }
            })
            .catch(error => {
              self.setState({ loader: false })
              console.error(error);
              params.failCallback();
            });
        }
      }
    };
  }

  LinkValueRenderer = (params) => {
    return (
      <a
        href=''
        title='View Pick up by'
        style={{
          color: '#385cad',
          fontWeight: 500,
          textDecoration: 'none ',
          fontSize: '1rem',
        }}
        onClick={(event) =>
          this.handlePUcodeClick(event, params.data.pmid)
        }
      >
        {' '}
        {params.value}
      </a>
    )
  }

  DateCellFormatter = (params) => {
    return this.convertToTimeZone(params.value)
  }

  DeliveryTypeFormatter = (t) => {
    return (params) => {
      const deliverType = getTypeByLang(params.value, t)
      return deliverType ? deliverType : ''
    }
  }

  handlePUcodeClick = (event, pmid) => {
    event.preventDefault();
    const selectedObject = this.state.data.find(x => x.pmid === pmid);
    this.setState({ detailDialogOpen: true, selectedObject: selectedObject })
    this.setState({
      boxAddress: (selectedObject.address_line_1 + ' '
        + selectedObject.address_line_2 + ','
        + selectedObject.city + ', '
        + selectedObject.state + ' '
        + selectedObject.zip + '')
    })
  }
  handlePUcodeClose = (event) => {
    event.preventDefault();
    this.setState({ detailDialogOpen: false, selectedObject: null })
  }
  handlePrintReceipt = () => {
    this.setState({ detailDialogOpen: false, printDialogOpen: true })
    setTimeout(() => {
      window.print();
      this.setState({ printDialogOpen: false, detailDialogOpen: false, selectedObject: null })
    }, 100);
  }

  AmountValueRenderer = (params) => {
    return params.value ? '$' + parseFloat(params.value).toFixed(2) : '$0.00'
  }

  render() {
    const { classes, t } = this.props;
    const { data, accountValues, boxvalues, locationvalues, statusvalues } = this.state;

    const columnDefs = [
      { field: "firstname", headerName: t("Report.Console.FirstName") },
      { field: "lastname", headerName: t("Report.Console.LastName") },
      {
        field: "store", headerName: t("Report.Console.Store"), filter: true,
        filterParams: {
          values: accountValues.map(account => {
            return account.name
          })
        },
        menuTabs: ['generalMenuTab', 'columnsMenuTab'],
      },
      {
        field: "box", headerName: t("Report.Console.Location"), filter: true,
        filterParams: {
          values: boxvalues.map(box => {
            return box.name
          })
        },
        menuTabs: ['generalMenuTab', 'columnsMenuTab'],
      },
      {
        field: "deliverytype", headerName: t("Report.Console.DeliverType"), cellRenderer: this.DeliveryTypeFormatter(t), filter: true,
        filterParams: {
          values: locationvalues.map(location => {
            return location.name
          })
        },
        menuTabs: ['generalMenuTab', 'columnsMenuTab'],
      },
      { field: "rxno", headerName: t("Report.Console.RxHash") },
      { field: "fillid", headerName: t("Report.Console.FillID") },
      { field: "prescriptionnumber", headerName: t("Report.Console.PrescriptionNumber") },
      { field: "pucode", headerName: t("Report.Console.PUCode"), cellRenderer: this.LinkValueRenderer },
      { field: "ndccode", headerName: t("Report.Console.NDCCode") },
      { field: "drugname", headerName: t("Report.Console.DrugName") },
      { field: "qty", headerName: t("Report.Console.Qty"), filter: false },
      { field: "price", headerName: t("Report.Console.AmountDue"), filter: false, cellRenderer: this.AmountValueRenderer },
      { field: "isConsultRequested", headerName: t("Report.Console.Consult"), filter: false },
      {
        field: "transaction_date", headerName: t("Report.Console.TransactionDate"),
        cellRenderer: this.DateCellFormatter,
        filter: 'agDateColumnFilter',
        filterParams: {
          filterOptions: [
            {
              displayKey: 'fromdate',
              displayName: t('Report.Console.FromDate'),
              predicate: (_, cellValue) => cellValue
            },
            {
              displayKey: 'todate',
              displayName: t('Report.Console.ToDate'),
              predicate: (_, cellValue) => cellValue
            },
          ],
          maxNumConditions: 2,
        },
      },
      { field: "username", headerName: t("Report.Console.User") },
      {
        field: "status", headerName: t("Report.Console.Status"), filter: true,
        filterParams: {
          values: statusvalues.map(status => {
            return status.name
          })
        },
        menuTabs: ['generalMenuTab', 'columnsMenuTab'],
      },
    ];
    return (
      <Paper id="react-no-print" className={classes.root}>
        {
          this.state.loader ?
            <div className={classes.spinner}>
              <img className={classes.spinnerImage} src={spinner} alt="loading" />
            </div> :
            null
        }
        <div id="react-no-print">
          <div id="react-no-print">
            <Dialog
              open={this.state.detailDialogOpen || false}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              PaperProps={{
                style: { borderRadius: '5px', maxWidth: '100%', width: '60%' }
              }}
            >
              <DialogTitle id="alert-dialog-title">{t("Report.Console.Popup.PickedUpBy")}</DialogTitle>
              <DialogContent>
                <Table aria-labelledby="tableTitle">
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.Console.Popup.FirstName")}</TableCell>
                      <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.Console.Popup.LastName")}</TableCell>
                      <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.Console.Popup.ContactlessPickup")}</TableCell>
                      <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.Console.Popup.DlNo")}</TableCell>
                      <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.Console.Popup.Signature")}</TableCell>
                      <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.Console.Popup.Picture")}</TableCell>
                      <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.Console.Popup.Relationship")}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {
                      this.state.selectedObject !== null ?
                        <TableRow>
                          <TableCell className={classes.padding10px} >{this.state.selectedObject.pfirst_name ? this.state.selectedObject.pfirst_name : ''}</TableCell>
                          <TableCell className={classes.padding10px}>{this.state.selectedObject.plast_name ? this.state.selectedObject.plast_name : ''}</TableCell>
                          <TableCell className={classes.padding10px}>{this.state.selectedObject.iscontactlessactivated === true ? 'Yes' : 'No'}</TableCell>
                          <TableCell className={classes.padding10px}>{this.state.selectedObject.pdrivers_license_no ? this.state.selectedObject.pdrivers_license_no : ''}</TableCell>
                          <TableCell className={classes.padding10px}><img style={{ borderRadius: '0%', width: '230px', height: '150px' }} alt="" src={(this.state.selectedObject.psignature_url !== null && this.state.selectedObject.psignature_url !== '') ? this.state.selectedObject.psignature_url : 'https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg'} /></TableCell>
                          <TableCell className={classes.padding10px}><Avatar style={{ borderRadius: '0%', width: '150px', height: '150px' }} alt="" src={(this.state.selectedObject.ppicture_url !== null && this.state.selectedObject.ppicture_url !== '') ? this.state.selectedObject.ppicture_url : 'https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg'} /></TableCell>
                          <TableCell className={classes.padding10px}>{this.state.selectedObject.relationship ? this.state.selectedObject.relationship.replace('_', ' ').replace('_', ' ') : ''}</TableCell>
                        </TableRow>
                        :
                        <TableRow>
                          <TableCell colSpan={5}>{t("Report.Console.NoDataFound")}</TableCell>
                        </TableRow>
                    }

                  </TableBody>
                </Table>
              </DialogContent>
              <DialogActions>
                <Button onClick={(e) => { this.handlePrintReceipt(e) }} color="primary" className={classes.primaryButton}>
                  {t("Report.Console.Popup.PrintReceiptButton")}
                </Button>
                <Button onClick={(e) => { this.handlePUcodeClose(e) }} color="primary" className={classes.primaryButton}>
                  {t("Report.Console.Popup.CloseButton")}
                </Button>
              </DialogActions>
            </Dialog>
          </div>
          <div>
            <Dialog
              open={this.state.printDialogOpen || false}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              fullWidth={true}
              PaperProps={{
                style: { maxWidth: '700px', maxHeight: '100%' }
              }}
            >
              <DialogTitle id="alert-dialog-title">{t("Report.Console.Receipt.PickedUpReceipt")}</DialogTitle>
              <DialogContent>
                <Table aria-labelledby="tableTitle">
                  {
                    this.state.selectedObject !== null ?
                      (<TableBody>
                        <TableRow className={classes.rowheight}>
                          <TableCell>{t("Report.Console.Receipt.PharmacyName")}:</TableCell>
                          <TableCell>{this.state.selectedObject.store}</TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell>{t("Report.Console.Receipt.KioskName")}:</TableCell>
                          <TableCell>{this.state.selectedObject.box}</TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell>{t("Report.Console.Receipt.Address")}:</TableCell>
                          <TableCell>{this.state && this.state.boxAddress}</TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell>{t("Report.Console.Receipt.PickupOrder")}:</TableCell>
                          <TableCell>{this.state.selectedObject.pucode}</TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell>{t("Report.Console.Receipt.PickupDate")}:</TableCell>
                          <TableCell>{this.state.selectedObject.pickupdate ? this.convertToTimeZone(this.state.selectedObject.pickupdate) : ''}</TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell>{t("Report.Console.Receipt.StockDate")}:</TableCell>
                          <TableCell>{this.state.selectedObject.stockeddate ? this.convertToTimeZone(this.state.selectedObject.stockeddate) : ''}</TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell>{t("Report.Console.Receipt.PatientName")}:</TableCell>
                          <TableCell>{this.state.selectedObject.username}</TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell style={{ borderBottom: 'none' }}><b>{t("Report.Console.Receipt.OrderDetail")}</b></TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <Table size="small" aria-label="a dense table">
                            {/* <TableHead> */}
                            <TableRow>
                              <TableCell>{t("Report.Console.Receipt.PrescriptionNumber")}</TableCell>
                              <TableCell align="right">{t("Report.Console.Receipt.RxNumber")}</TableCell>
                              <TableCell align="right">{t("Report.Console.Receipt.FillID")}</TableCell>
                            </TableRow>
                            {/* </TableHead> */}
                            <TableBody>
                              {/* {rows.map((row) => ( */}
                              <TableRow className={classes.rowheight}>
                                <TableCell component="th" scope="row">
                                  {this.state.selectedObject.rxno}
                                </TableCell>
                                <TableCell align="right">{this.state.selectedObject.prescriptionnumber}</TableCell>
                                <TableCell align="right">{this.state.selectedObject.fillid}</TableCell>
                              </TableRow>
                              {/* ))} */}
                            </TableBody>
                          </Table>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell style={{ borderBottom: 'none' }}><b>{t("Report.Console.Receipt.Signature")}</b></TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell><Avatar style={{ border: '1px solid rgba(224, 224, 224, 1)', borderRadius: '0%', width: '100%', height: '150px' }} alt="" src={(this.state.selectedObject.psignature_url !== null && this.state.selectedObject.psignature_url !== '') ? this.state.selectedObject.psignature_url : 'https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg'} /></TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell style={{ borderBottom: 'none' }}><b>{t("Report.Console.Receipt.PickedUpBy")}</b></TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell>{t("Report.Console.Receipt.FirstName")}:</TableCell>
                          <TableCell>{this.state.selectedObject.pfirst_name}</TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell>{t("Report.Console.Receipt.LastName")}:</TableCell>
                          <TableCell>{this.state.selectedObject.plast_name}</TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell>{t("Report.Console.Receipt.IDNo")}:</TableCell>
                          <TableCell>{this.state.selectedObject.pdrivers_license_no}</TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell><Avatar style={{ borderRadius: '0%', width: '60%', height: '150px' }} alt="" src={(this.state.selectedObject.ppicture_url !== null && this.state.selectedObject.ppicture_url !== '') ? this.state.selectedObject.ppicture_url : 'https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg'} /></TableCell>
                        </TableRow>
                      </TableBody>)
                      :
                      (<TableBody>
                        <TableRow>
                          <TableCell colSpan={5}>{t("Report.Console.NoDataFound")}</TableCell>
                        </TableRow>
                      </TableBody>)
                  }
                </Table>
              </DialogContent>
            </Dialog>
          </div>
          <Box component="div">
            <Grid container direction={'row'} alignItems={'center'} justifyContent={'flex-end'} spacing={0} sx={{ ml: 0, mr: 1, width: '100%', border: 'solid 1px #babfc7', borderBottom: 'none' }}>
              <Grid item xs={3} md={3} sx={{ textAlign: 'end' }}>
                <Tooltip key="clear-filters" title={t("Report.Console.ClearFiltersTooltip")}>
                  <IconButton onClick={() => this.clearFilters()} style={{ backgroundColor: "#00a7e1" }}>
                    <CloseIcon style={{ color: "white" }} />
                  </IconButton>
                </Tooltip>
                <Tooltip key="export-csv" title={t("Report.Console.ExportCSV")}>
                  <IconButton
                    style={{ marginRight: '0' }}
                    aria-label="ExportCSV"
                    onClick={() => { this.exportCSV() }}
                    disabled={this.state.isButtonDisabled}
                  >
                    <img alt="download" src={download} style={{ height: '32px', width: '32px', cursor: 'pointer' }} />
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>
          </Box>
        </div>
        {accountValues.length && boxvalues.length ?
          <ReportsAGGrid
            columnDefs={columnDefs}
            sideBar={false}
            suppressMenuHide={true}
            rowData={data}
            defaultColDef={{
              flex: 1,
              minWidth: 150,
              floatingFilter: true,
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: [{
                  displayKey: 'searchtext',
                  displayName: 'Search Text',
                  predicate: (cellValue) => cellValue
                }],
                maxNumConditions: 1,
              },
              resizable: true,
              sortable: true,
              menuTabs: ['generalMenuTab', 'columnsMenuTab'],
            }}
            onGridReady={this.onGridReady}
          />
          : null
        }
      </Paper>
    );
  }
}

ConsoleReport.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(withTranslation()(ConsoleReport));



// WEBPACK FOOTER //
// ./src/components/reports/console-report/index.js